import { AUTH_TOKEN } from "constants/AuthConstant"
import fetch from "auth/FetchInterceptor"

const DoctorSubscriptionService = {
  // Assign subscription plan to doctor
  assignPlanToDoctor: (doctorId, planData) => {
    return fetch({
      data: planData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "post",
      url: `/admin/doctors/${doctorId}/subscription`,
    })
  },

  // Cancel doctor's subscription
  cancelDoctorSubscription: (doctorId) => {
    return fetch({
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "delete",
      url: `/admin/doctors/${doctorId}/subscription`,
    })
  },

  // Get all doctors with subscription status
  getAllDoctorsWithSubscriptions: (page = 1, limit = 10) => {
    return fetch({
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "get",
      url: `/admin/doctors/subscriptions?page=${page}&limit=${limit}`,
    })
  },

  // Get doctor's subscription status
  getDoctorSubscription: (doctorId) => {
    return fetch({
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "get",
      url: `/admin/doctors/${doctorId}/subscription`,
    })
  },

  // Renew doctor's subscription
  renewDoctorSubscription: (doctorId, planType) => {
    return fetch({
      data: { planType },
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "put",
      url: `/admin/doctors/${doctorId}/subscription/renew`,
    })
  },
}

export default DoctorSubscriptionService